module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "astro-clock"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel site_lights"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/weather.svg")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sunset"
  }, [_vm._v(_vm._s(_vm.clock.sunset_time))]), _vm._v(" "), _c('div', {
    staticClass: "sunset_desc"
  }, [_vm._v(_vm._s(_vm.clock.sunset_description1))]), _vm._v(" "), _c('div', {
    staticClass: "sunset_desc"
  }, [_vm._v(_vm._s(_vm.clock.sunset_description2))]), _vm._v(" "), _c('div', {
    staticClass: "lights_desc"
  }, [_c('div', [_vm._v("Lights won't turn on before: "), _c('strong', [_vm._v(_vm._s(_vm.lights.on))])]), _vm._v(" "), _c('div', [_vm._v("Lights AUTO Off: "), _c('strong', [_vm._v(_vm._s(_vm.offTime))])])]), _vm._v(" "), _c('div', {
    staticClass: "light_btns"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("OVERRIDE")]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "save"
    },
    on: {
      "click": function($event) {
        _vm.confirmAllLights('on')
      }
    }
  }, [_vm._v("Lights On")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "cancel"
    },
    on: {
      "click": function($event) {
        _vm.confirmAllLights('off')
      }
    }
  }, [_vm._v("Lights Off")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panelheader"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Astro Clock")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-206c6338","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteAstroClock.vue
// module id = 831
// module chunks = 4